import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import user from './modules/user';
import tagsView from './modules/tagsView';
import permission from './modules/permission';
import oss from './modules/ossClient';
import customer from './modules/customer';
import twitter from './modules/twitter';
import seo from './modules/seo';
import googleAds from './modules/googleAds';
import inquiry from './modules/inquiry';
import chat from './modules/chat';
import getters from './getters';
import aiAds from "@/backend/store/modules/aiAds";

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		aiAds,
		app,
		user,
		tagsView,
		permission,
		oss,
		customer,
		twitter,
		seo,
		googleAds,
		inquiry,
		chat,
	},
	getters,
});

export default store;
